<div class="d-flex justify-content-between selection-header">
    <h3 class="m-0 semi-bold">{{'Select-Subscription-for' | translate}}
        <a style="text-decoration: none;" href="#"> {{plan[0].facilitySubscriptionDetails[0].facilityName}}</a>
    </h3>
    <span class="material-icons cursor" (click)="onCloseDialog()">
        clear
    </span>
</div>
<div class="info-contain">
    <div class="d-flex justify-content-between align-items-center info-contain-toggle" *ngIf="subscriptionPlans.length">

        <div class="d-flex">
            <img class="app-image h-21" *ngIf="planDetails.appIconUrl != null" [src]="planDetails.appIconUrl">
            <h4 class="m-0 semi-bold">
                <a style="text-decoration: none;" href="#"> {{planDetails.appName}}</a>
            </h4>
        </div>
        <div class="message-icon">
            <mat-button-toggle-group name="" [(ngModel)]="planType" (ngModelChange)="planTypeChange($event)">
                <mat-button-toggle [value]="'annualPlan'">
                    {{'Annual'|translate}}
                </mat-button-toggle>
                <mat-button-toggle [value]="'monthlyPlan'">{{'Monthly'|translate}}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>

    <div style="overflow-x:auto;" class="d-flex w-100" *ngIf="subscriptionPlans.length">
        <mat-radio-group class="w-100" [(ngModel)]="planId" (change)="planChange($event.value)">
            <div class="row">
                <div class="col-sm-6 col-md-4 col-lg-3 col-sm-6 col-md-4 col-lg-3 subscriptCard cardPad" *ngFor="let item of subscriptionPlans;let i =index;">
                    <div class="subscript-container-inner w-100" [ngClass]="{ 'plan-active': item.planId==selectedIndex, 'AddonBox' : item?.isAddOn}">
                        <div class="currentPlan" *ngIf="item.planId==selectedIndex">
                            <button mat-raised-button color="primary" class="text-uppercase card-header-action">{{'CurrentPlan' | translate}}</button>
                        </div>
                        <div class="w-100">

                            <mat-radio-button class="custom-radio" [value]="item.planId"> </mat-radio-button>

                            <div class="header-contain flex-column text-center d-flex justify-content-center">
                                <p class="m-0 d-flex justify-content-center">
                                    <img class="sub-img mb-2" [src]="item.planIconUrl" />
                                </p>
                                <span class="planTittle">{{item.planName}}</span>
                                <div class="description_container">
                                    <p matTooltipClass="tooltip-no-ellipsis" matTooltip="{{item.planShortDescription}}" class="description" style=" text-overflow: ellipsis; 
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                            overflow: hidden;">{{item.planShortDescription}}</p>
                                </div>

                            </div>
                            <div class="middle-contain">
                                <p class="m-0 text-center semi-bold mt-3 planCount" *ngIf="item.planFeatureDetails.userLicense">1 {{'Institution' | translate}}
                                    <br/> {{item?.planFeatureDetails?.userLicense}} {{'User' | translate}}</p>
                                <p>
                                    <label class="p-3"> {{'Features'|translate}}</label>
                                </p>
                                <div class="mt-2">
                                    <ng-container *ngFor="let innerItem of item.subscriptionPlanFeatures">
                                        <h6 class="d-flex m-0" *ngIf="!!innerItem.isEnabled">
                                            <span class="material-icons done-clr" *ngIf="!!innerItem.isEnabled">done</span>
                                            <span class="semi-bold" *ngIf="!!innerItem.isEnabled">{{getFeatureName(innerItem.featureName)}}</span>
                                        </h6>
                                    </ng-container>
                                </div>
                            </div>

                        </div>
                        <div class="text-center request-plan mb-3 mt-2">
                            <h2 class="text-center mb-3 mt-2 blue-text" *ngIf="planType=='monthlyPlan' && item.monthlyCost && !item?.planFeatureDetails?.operationalSupport"
                                [ngStyle]="{'color': item.planColourTheme }">€ {{item.monthlyCost | number : '1.2-2'}}
                                <span [ngStyle]="{'color': item.planColourTheme }">/{{('month'|translate)}}</span>
                            </h2>
                            <h2 class="text-center mb-3 mt-2 blue-text" *ngIf="planType=='annualPlan' && item.annualCost && !item?.planFeatureDetails?.operationalSupport"
                                [ngStyle]="{'color': item.planColourTheme }">€ {{item.annualCost | number : '1.2-2'}}
                                <span [ngStyle]="{'color': item.planColourTheme }">/{{('year'|translate)}}</span>
                            </h2>
                            <h2 class="text-center mb-3 mt-2 blue-text" style="font-size: 28px;" *ngIf="item?.planFeatureDetails?.operationalSupport"
                                [ngStyle]="{'color': item.planColourTheme }">{{('ForFree'|translate)}}</h2>
                            <div *ngIf="requestedPlan != null && requestedPlan.planId == item.planId" class="text-center mb-4 mt-2">
                                <span class="blue-text font-14">{{'Request-sent'|translate}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="Addon-container py-3" *ngIf="item?.isAddOn" [ngClass]="{ 'plan-active': item.planId==selectedIndex}">
                        <h3 class="text-center m-0 py-3 font-weight-bold">{{'+Add-on'|translate}}</h3>
                        <p class="text-center m-0 semi-bold">{{'Each-Institution'|translate}}</p>
                        <h2 style="font-size: 28px;" class="text-center m-0 mt-3 blue-text" *ngIf="planType=='monthlyPlan' && item?.addOnMonthlyCost"
                            [ngStyle]="{'color': item.planColourTheme }">€ {{item.addOnMonthlyCost | number : '1.2-2'}}
                            <span [ngStyle]="{'color': item.planColourTheme }">/{{('month'|translate)}}</span>
                        </h2>
                        <h2 style="font-size: 28px;" class="text-center m-0 mt-3 blue-text" *ngIf="planType=='annualPlan' && item?.addOnAnnualCost"
                            [ngStyle]="{'color': item.planColourTheme }">€ {{item.addOnAnnualCost | number : '1.2-2'}}
                            <span [ngStyle]="{'color': item.planColourTheme }">/{{('year'|translate)}}</span>
                        </h2>
                    </div>
                </div>
            </div>
        </mat-radio-group>


    </div>
    <div class="col-12 col-lg-12  pt-2 text-center" style="color: #ff0000" *ngIf="!subscriptionPlans.length">
        {{'warningMessageForSubscription'|translate}}
    </div>
</div>
<div class="col-12 col-lg-12  pt-3">
    <div class="pb-3 text-center">
        <button mat-raised-button color="accent" class="card-header-action mr-3" (click)="onCloseDialog()">{{'Cancel' | translate}}</button>
        <button mat-raised-button color="primary" [disabled]="!setChange" class="card-header-action" (click)="selectPlan()">{{'Select' | translate}} </button>

    </div>
</div>